import { useEffect, useState } from 'react';
import { getCall } from './Network';
import { t } from 'i18next';

const useGeneratePillarsToken = () => {
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [username, setUsername] = useState(undefined);
  const [password, setPassword] = useState(undefined);
  const [loginError, setLoginError] = useState(undefined);

  const login = async () => {
    let data = {
      fullUrl: 'https://api.pillarshub.com/Authentication',
      urlParams: { username: username, password: password },
    };
    setLoading(true);
    setLoginError(undefined);
    const authData = await getCall(data);
    setLoading(false);
    setRefreshing(false);
    if (authData.status == 200 && authData?.data?.userId) {
      localStorage.setItem(
        'pillarToken',
        JSON.stringify(authData?.data?.authToken?.token)
      );
    } else {
      setLoginError(t('incorrectUsernameOrPassword'));
    }
  };
  useEffect(() => {
    if (username && password && refreshing && !loading) {
      login();
    }
  }, [username, password, refreshing, loading]);

  return { setUsername, setPassword, loginError, refresh: () => setRefreshing(true) };
};

export default useGeneratePillarsToken;
